import React from 'react';
import {Box, Grid} from '@mui/material';
import { AppState } from '../../types/types';

interface Props {
    header?: any,
    children?: any,
    appState:AppState,
}

const ContentWrapper : React.FC<Props> = ({header, children, appState}) => {

    return <Box className={"answer-element "}
            sx={{
                backgroundColor: 'inherit',
                borderBottom: '1px solid',
                borderBottomColor: '#ffffff',
                borderLeft: '1px solid #ffffff42',
                padding: '1rem',
                background: appState?.customizing?.colors?.decentBackground || 'linear-gradient(170deg, rgb(255 255 255 / 15%) 0%, rgba(255,255,255,0) 100%)',
                "&:nth-child(even)":{
                    background: appState?.customizing?.elements?.backgroundEven || 'linear-gradient(170deg, rgb(255 255 255 / 15%) 0%, rgba(255,255,255,0) 100%)',
                },
                "&:nth-child(odd)": {
                    background: appState?.customizing?.elements?.backgroundOdd || 'linear-gradient(170deg, rgb(255 255 255 / 15%) 0%, rgba(255,255,255,0) 100%)',
                },
                ...appState?.customizing?.elements?.styleOverrides??{}
            }}>                
            <Grid container spacing={3}>
                {header && <Grid item xs={11} className="answer-element-heading" sx={{
                    fontSize: '1.1rem', 
                    fontWeight: 600, 
                    paddingBottom: '1rem'                   
                    }}>
                    <div>{header}</div>
                </Grid>}
                
                {
                    children
                }
            </Grid>
        </Box>
}

export default ContentWrapper;